module.exports = __webpack_public_path__ + "img/ic_flat_gem@2x.0bf0295d.png";